export default {"src":"/_next/static/media/trx.db5dec66.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};